import CurrentSessionModal from './CurrentSessionModal';

export default CurrentSessionModal;
